import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const loc = useLocation();
    const { completeGoogle } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = loc.hash || window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        const role = localStorage.getItem("flow_pending_role") || "student";
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);
        completeGoogle(sessionId, role)
            .then((u) => {
                localStorage.removeItem("flow_pending_role");
                navigate(u.role === "teacher" ? "/dashboard" : "/curriculum", {
                    replace: true,
                });
            })
            .catch(() => {
                navigate("/login?err=google", { replace: true });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main
            className="min-h-screen flex items-center justify-center"
            data-testid="auth-callback"
        >
            <p className="font-mono text-[var(--lime)]">
                signing you in…
            </p>
        </main>
    );
}
